import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { PERMISSIONS } from '@property/shared';
import { usePermissions } from '@/hooks/use-permissions';
import { FeedbackList } from '@/features/feedback/components/FeedbackList';

export const Route = createFileRoute('/dashboard/feedback/')({
  component: FeedbackPage,
});

function FeedbackPage() {
  const { can, isLoading } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !can(PERMISSIONS.FEEDBACK_READ)) {
      navigate({ to: '/dashboard' });
    }
  }, [can, isLoading, navigate]);

  if (isLoading) return null;
  if (!can(PERMISSIONS.FEEDBACK_READ)) return null;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="font-display text-2xl font-medium tracking-tight text-foreground">
          Feedback
        </h1>
        <p className="text-muted-foreground text-sm mt-1">
          View and manage all user feedback and contact queries.
        </p>
      </div>

      <FeedbackList />
    </div>
  );
}
